export const isMobile = {
    Android() {
        return navigator.userAgent.match(/Android/i)
    },
    BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i)
    },
    iOS() {
        return navigator.userAgent.match(/iPhone|iPod/i) || isMobile.iPad()
    },
    Opera() {
        return navigator.userAgent.match(/Opera Mini/i)
    },
    Windows() {
        return navigator.userAgent.match(/IEMobile/i)
    },
    iPad() {
        return (
            navigator.userAgent.match(/iPad/i) ||
            (navigator.userAgent.match(/Macintosh/i) && window.navigator.maxTouchPoints > 2)
        )
    },
    Samsung() {
        return navigator.userAgent.match(/(SAMSUNG|SM-|SamsungBrowser)/) && isMobile.Android()
    },
    phone() {
        return window.matchMedia('(max-width: 767px)').matches && isMobile.hasTouch()
    },
    tablet() {
        return window.matchMedia('(max-width: 1024px)').matches && isMobile.hasTouch()
    },
    hasTouch() {
        return navigator.maxTouchPoints > 2
    },
    any() {
        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows()
    },
    anyStrict() {
        return isMobile.any() && isMobile.hasTouch() && (isMobile.phone() || isMobile.tablet())
    },
}
